import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.25 3a.75.75 0 0 1 1.5 0v14h2.133c.993 0 1.49 1.174.788 1.861l-2.883 2.82a1.133 1.133 0 0 1-1.576 0l-2.883-2.82C7.626 18.174 8.124 17 9.117 17h2.133z"
    }, null, -1)
  ])))
}
export default { render: render }